import React from 'react';

import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route, Link } from 'react-router';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import TouchButton from '../components/TouchButton';
import Difficulty from '../components/Difficulty/Difficulty';

const AssessmentDifficulty = React.createClass({
	mixins: [ReactFireMixin],

	getInitialState: function () {
		return {
			book: null,
			chapters: null
		};
	},

	componentWillMount: function () {
		this.bindAsObject(firebaseRoot.child('content/books').child(this.props.params.bookId), "book");
		this.bindAsArray(firebaseRoot.child('content/chapters').child(this.props.params.bookId), "chapters");
	},

	generateTest(e) {
		e.preventDefault();
		// TODO: Generate test
	},

	render() {

		return(
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='default'
					title='Välj svårighetsgrad'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<form onSubmit={this.generateTest} className="section-wrap">
						<div className="section-body">
							<ol className="chapters-list">
								<Difficulty
									difficulty="easy"
									title="Lätt"
								    recommended
								    extra={`Recommended <i class="glyphicon glyphicon-thumbs-up"></i>`}
								    extraClass="difficulty-recommended"
								/>
								<Difficulty
									difficulty="medium"
									title="Medium"
								/>
								<Difficulty
									difficulty="hard"
									title="Svår"
								/>
							</ol>
						</div>
						<div className="section-footer">
							<TouchButton type="submit" bsStyle="primary" bsSize="large" block>Generera prov</TouchButton>
						</div>
					</form>
				</div>
			</div>
		);
	}
});

export default AssessmentDifficulty;



/** WEBPACK FOOTER **
 ** ./src/screens/AssessmentDifficulty.js
 **/